import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateSettingsAction } from "../../actions/settings";
import { SILVER_BID_PRICE } from "../../constants";

export default function SilverBidMapping({ data }) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    reset(data)
  }, [data])


  const onSubmit = (data) => {
    const payload = {
      silverBidMapping: data,
    }
    dispatch(updateSettingsAction(payload));
  };
  return (
    <>
      {/* <div className="card-body"> */}
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="form-group form-margin">
          <div className="row">
            <label className="col-form-label edit-info">Enter Silver big price mapping</label>

            {SILVER_BID_PRICE.map((item, index) => (
              <div className="col-lg-4" key={index}>
                <span className="input-text">{item?.name} *</span>
                <input
                  maxLength={500}
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  placeholder="Enter plan/product id"
                  {...register(item?.value, { required: true })}
                />
                {errors[item?.value]?.type === "required" && (
                  <span className="errorMessage">This field is required</span>
                )}
              </div>
            ))}

          </div>
        </div>
        <button type="submit" className="btn agree-button save-btn mt-3">
          Save changes
        </button>
      </form >
      {/* </div> */}
    </>
  );
}
